(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroes = document.querySelectorAll('[data-hero]');
  for(var h = 0; h < heroes.length; h++){ initHero(heroes[h]); }

  function initHero(hero){
    if(!hero) return;

    // 載入後觸發分段 reveal
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ hero.classList.add('loaded'); });
    });

    // 視差層
    var px = hero.querySelector('[data-hero-parallax]');
    if(!reduce && px){
      var ticking = false;
      var onScroll = function(){
        if(ticking) return;
        ticking = true;
        window.requestAnimationFrame(function(){
          var y = window.scrollY || 0;
          px.style.setProperty('--py', (y * 0.32).toFixed(1) + 'px');
          ticking = false;
        });
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // 輪播：交叉淡入（reduce 時不自動播放，靜態顯示第一張）
    var slides = hero.querySelectorAll('[data-hero-slide]');
    if(!reduce && slides.length > 1){
      var idx = 0;
      setInterval(function(){
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, 5500);
    }

    // overdrive：暖光塵埃（窗光裡漂浮的微塵）
    var motes = hero.querySelector('[data-hero-motes]');
    if(motes && !reduce && motes.getContext){
      var mctx = motes.getContext('2d');
      var mw = 0, mh = 0, mdpr = 1, particles = [], motesRaf = null;
      var mResize = function(){
        mdpr = Math.min(window.devicePixelRatio || 1, 2);
        var rect = hero.getBoundingClientRect();
        mw = Math.max(1, Math.round(rect.width)); mh = Math.max(1, Math.round(rect.height));
        if(!mw || !mh) return;
        motes.width = Math.round(mw * mdpr); motes.height = Math.round(mh * mdpr);
        mctx.setTransform(mdpr, 0, 0, mdpr, 0, 0);
        var n = Math.max(12, Math.min(28, Math.round(mw / 52)));
        particles = [];
        for(var i = 0; i < n; i++){
          particles.push({
            x: Math.random() * mw, y: Math.random() * mh,
            r: 0.6 + Math.random() * 1.9, a: 0.05 + Math.random() * 0.16,
            vy: -(0.05 + Math.random() * 0.16), vx: (Math.random() - 0.5) * 0.10,
            ph: Math.random() * Math.PI * 2
          });
        }
      };
      var drawMotes = function(t){
        mctx.clearRect(0, 0, mw, mh);
        mctx.shadowColor = 'rgba(224,180,122,0.9)'; mctx.shadowBlur = 6;
        mctx.fillStyle = 'rgba(230,190,135,1)';
        for(var i = 0; i < particles.length; i++){
          var p = particles[i];
          p.y += p.vy; p.x += p.vx + Math.sin(t / 2400 + p.ph) * 0.04;
          if(p.y < -4){ p.y = mh + 4; p.x = Math.random() * mw; }
          if(p.x < -4) p.x = mw + 4; else if(p.x > mw + 4) p.x = -4;
          mctx.globalAlpha = p.a;
          mctx.beginPath(); mctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); mctx.fill();
        }
        mctx.globalAlpha = 1; mctx.shadowBlur = 0;
        motesRaf = requestAnimationFrame(drawMotes);
      };
      var startMotes = function(){ if(motesRaf == null) motesRaf = requestAnimationFrame(drawMotes); };
      var stopMotes = function(){ if(motesRaf != null){ cancelAnimationFrame(motesRaf); motesRaf = null; } };
      mResize();
      window.addEventListener('resize', mResize);
      if('IntersectionObserver' in window){
        var mio = new IntersectionObserver(function(es){
          es.forEach(function(e){ if(e.isIntersecting){ startMotes(); } else { stopMotes(); } });
        }, { threshold: 0 });
        mio.observe(hero);
      } else { startMotes(); }
    }
  }
})();
